import { render, staticRenderFns } from "./CommentsBlock.vue?vue&type=template&id=abc1d8b4&scoped=true&"
import script from "./CommentsBlock.vue?vue&type=script&lang=js&"
export * from "./CommentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBlock.vue?vue&type=style&index=0&id=abc1d8b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc1d8b4",
  null
  
)

export default component.exports